import { debounce } from '@/lib/lodash'

export const initSpoilerPlugin = () => {
  if (CKEDITOR.plugins.get('spoiler')) {
    return
  }

  CKEDITOR.plugins.add('spoiler', {
    requires: 'richcombo',
    init(editor) {
      const blurCommand = 'blurTextCommand'
      const flickerCommand = 'flickerTextCommand'
      const removeHiddenTextCommand = 'removeHiddenTextCommand'

      // @ts-ignore
      const blurStyle = new CKEDITOR.style({
        name: 'blur-style',
        element: 'span',
        attributes: {
          class: 'widget-spoiler widget-spoiler-blur',
        },
      })

      // @ts-ignore
      const flickerStyle = new CKEDITOR.style({
        name: 'flicker-style',
        element: 'span',
        attributes: {
          class: 'widget-spoiler widget-spoiler-flicker',
        },
      })

      const buttons = new Map([
        [
          blurCommand,
          {
            style: blurStyle,
            params: {
              label: 'Блюр',
              command: blurCommand,
              toolbar: 'insert',
            },
          },
        ],
        [
          flickerCommand,
          {
            style: flickerStyle,
            params: {
              label: 'Мерцание',
              command: flickerCommand,
              toolbar: 'insert',
            },
          },
        ],
      ])

      // @ts-ignore
      editor.ui.addButton('RemoveHiddenText', {
        label: 'Показать',
        command: removeHiddenTextCommand,
      })

      // @ts-ignore
      editor.ui.addButton('blur-text-button', buttons.get(blurCommand).params)

      editor.ui.addButton(
        'filcker-text-button',
        // @ts-ignore
        buttons.get(flickerCommand).params
      )

      editor.addCommand(removeHiddenTextCommand, {
        // @ts-ignore
        exec() {
          editor.focus()
          editor.removeStyle(flickerStyle)
          editor.removeStyle(blurStyle)
        },
      })

      editor.addCommand(blurCommand, {
        // @ts-ignore
        exec() {
          editor.focus()

          editor.removeStyle(flickerStyle)
          editor.removeStyle(blurStyle)

          editor.focus()
          editor.applyStyle(blurStyle)
        },
      })

      editor.addCommand(flickerCommand, {
        // @ts-ignore
        exec() {
          editor.focus()

          editor.removeStyle(blurStyle)
          editor.removeStyle(flickerStyle)

          editor.focus()
          editor.applyStyle(flickerStyle)
        },
      })

      const getSpoilerToolEl = () => {
        const spoilerWidgetId = editor.ui.get('SpoilerWidget')?.id
        const spoilerWidgetEl = spoilerWidgetId
          ? document.getElementById(`cke_${spoilerWidgetId}`)
          : null

        return spoilerWidgetEl
      }

      const toggleShowText = (value: boolean) => {
        const removeHiddenTextId = editor.ui.get('RemoveHiddenText')?._?.id
        const removeHiddenTextEl = document.getElementById(removeHiddenTextId)

        const spoilerWidgetEl = getSpoilerToolEl()

        if (removeHiddenTextEl) {
          removeHiddenTextEl.hidden = !value
        }

        if (spoilerWidgetEl) {
          spoilerWidgetEl.hidden = value
        }
      }

      const toggleDisableSpoilerTool = (isDisabled: boolean) => {
        const spoilerWidgetEl = getSpoilerToolEl()

        if (!spoilerWidgetEl) {
          return
        }

        spoilerWidgetEl.style.opacity = isDisabled ? '0.5' : ''
        spoilerWidgetEl.style.pointerEvents = isDisabled ? 'none' : ''
      }

      editor.ui.addRichCombo('SpoilerWidget', {
        label: 'Скрыть',
        title: 'Скрыть текст',
        toolbar: 'insert',
        panel: {
          css: [CKEDITOR.skin.getPath('editor')].concat(
            editor.config.contentsCss
          ),
        },
        init() {
          this.add(
            blurCommand,
            // @ts-ignore
            buttons.get(blurCommand).params.label,
            // @ts-ignore
            buttons.get(blurCommand).params.label
          )

          this.add(
            flickerCommand,
            // @ts-ignore
            buttons.get(flickerCommand).params.label,
            // @ts-ignore
            buttons.get(flickerCommand).params.label
          )

          this.refresh = debounce(this.refresh, 50, {
            maxWait: 50,
          })
        },
        onOpen() {
          this._.list?.element?.$?.classList.add('spoiler-widget-panel-block')

          this.refresh()
        },
        onRender() {
          editor.on('focus', () => {
            this.refresh()
          })

          editor.on('selectionChange', () => {
            toggleDisableSpoilerTool(!!editor.editable().findOne('.cosmohint'))

            this.refresh()
          })
        },
        // @ts-ignore
        onClick(command) {
          editor.fire('saveSnapshot')

          editor.execCommand(command)

          editor.fire('saveSnapshot')
        },
        refresh() {
          const panelEl = this._.list?.element?.$

          const itemEls = panelEl?.querySelectorAll(
            `.cke_panel_listItem a[role="option"]`
          )

          let activeCommandName = ''

          for (const button of buttons.values()) {
            const editorElementPath = editor.elementPath()

            const isActive = editorElementPath
              ? button.style.checkActive(editorElementPath, editor)
              : false

            if (isActive) {
              activeCommandName = button.params.command

              toggleShowText(isActive)

              break
            }

            toggleShowText(false)
          }

          // @ts-ignore
          itemEls?.forEach((itemEl) => {
            const itemCommandName = itemEl.href.match(
              /javascript:void\('(.+)'\)/
            )?.[1]

            itemEl.parentElement.classList.toggle(
              'cke_selected',
              activeCommandName === itemCommandName
            )

            itemEl.blur()
          })
        },
      })
    },
  })
}
